import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  BookIcon,
  CommunityIcon,
  InfoIcon,
  PersonIcon,
  PulseIcon,
  ResourceIcon,
  SearchIcon,
} from 'app/components/shared/icons';
import Calendar from 'app/components/shared/icons/calendar';
import useBehavioral from 'hooks/useBehavioral';
import useUserData from 'hooks/useUserData';
import { setIsNavbarMenuOpen } from 'store/reducers/navbar-reducer';
import { searchHighlightsSelector } from 'store/reducers/user-reducer';

import NavTile from '../../NavTile';
import MobileMenuSearch from '../MobileMenuSearch';
import {
  MobileMenuTilesContainer,
  MobileMenuTilesContent,
  MobileMenuTilesTitle,
  MobileMenuTilesWrapper,
} from './styled';

export default function MobileMenuTiles() {
  const userData = useUserData();
  const dispatch = useDispatch();
  const canAccessBD100 = userData?.permissions?.bd100_access === true;
  const highlightedSearches = useSelector(searchHighlightsSelector);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const aboutKyuOsBehavioral = useBehavioral('NAV_ABOUT_KYU_OS');
  const theWellBehavioral = useBehavioral('NAV_THE_WELL');
  const communitiesBehavioral = useBehavioral('NAV_COMMUNITIES');
  const resourcesBehavioral = useBehavioral('NAV_RESOURCES');
  const eventsBehavioral = useBehavioral('NAV_EVENTS');
  const teamingBehavioral = useBehavioral('NAV_TEAMING');
  const peopleBehavioral = useBehavioral('NAV_PEOPLE');

  const handleSearchClick = () => {
    setShowSearch(true);
  };

  const handleSearchCloseMenu = () => {
    dispatch(setIsNavbarMenuOpen(false));
    setShowSearch(false);
  };

  return (
    <MobileMenuTilesWrapper>
      <MobileMenuTilesContent>
        <MobileMenuTilesTitle>EXPLORE</MobileMenuTilesTitle>
        <MobileMenuTilesContainer>
          {canAccessBD100 ? (
            <NavTile
              navTile={{
                icon: <ResourceIcon />,
                title: 'BD 100',
                text: 'A space for 100 business development leaders across kyu to collaborate and drive growth.',
                route: { pathname: '/bd-100' },
              }}
              onClick={() => {
                dispatch(setIsNavbarMenuOpen(false));
              }}
            />
          ) : null}
          <NavTile
            navTile={{
              icon: <InfoIcon />,
              title: 'kyu 101',
              text: 'Dive deeper into how this platform works, where the data comes from and other FAQs.',
              route: { pathname: '/kyu-101' },
            }}
            onClick={() => {
              aboutKyuOsBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
          <NavTile
            navTile={{
              icon: <PulseIcon />,
              title: 'Pulse',
              text: `Learn more about the Collective's newest joint marketing and experiential initiative.`,
              route: { pathname: '/pulse' },
            }}
            onClick={() => {
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
          <NavTile
            navTile={{
              icon: <CommunityIcon />,
              title: 'Communities',
              text: 'Ways to engage and connect with others in the Collective.',
              route: { pathname: '/communities' },
            }}
            onClick={() => {
              communitiesBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
          <NavTile
            navTile={{
              icon: <Calendar />,
              title: 'Events',
              text: 'Ways to engage and connect with others in the Collective.',
              route: { pathname: '/communities', hash: 'upcoming-events' },
            }}
            onClick={() => {
              eventsBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
          <NavTile
            navTile={{
              icon: <BookIcon />,
              title: 'The Well',
              text: 'The Well is where you can find stories from around the collective about our work.',
              route: { pathname: '/the-well' },
            }}
            onClick={() => {
              theWellBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
          <NavTile
            navTile={{
              icon: <SearchIcon />,
              title: 'Search',
              text: 'Explore the Collective’s growing, interactive knowledge base',
            }}
            onClick={handleSearchClick}
          />
          <NavTile
            navTile={{
              icon: <ResourceIcon />,
              title: 'Resource Library',
              text: 'Explore the kyu knowledge base.',
              route: { pathname: '/resources' },
            }}
            onClick={() => {
              resourcesBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
        </MobileMenuTilesContainer>
      </MobileMenuTilesContent>
      <MobileMenuTilesContent>
        <MobileMenuTilesTitle>TOOLS</MobileMenuTilesTitle>
        <MobileMenuTilesContainer>
          {userData?.permissions?.teaming_access ? (
            <NavTile
              navTile={{
                icon: <ResourceIcon />,
                title: 'Teaming',
                text: 'Find eligible talent for projects.',
                route: { pathname: '/teaming' },
              }}
              onClick={() => {
                teamingBehavioral();
                dispatch(setIsNavbarMenuOpen(false));
              }}
            />
          ) : null}
          <NavTile
            navTile={{
              icon: <PersonIcon />,
              title: 'Collective Directory',
              text: 'Find and contact anyone in the Collective.',
              route: { pathname: '/people' },
            }}
            onClick={() => {
              peopleBehavioral();
              dispatch(setIsNavbarMenuOpen(false));
            }}
          />
        </MobileMenuTilesContainer>
      </MobileMenuTilesContent>
      <MobileMenuTilesContainer>
        {showSearch && (
          <MobileMenuSearch
            onClose={() => setShowSearch(false)}
            closeMenu={handleSearchCloseMenu}
          />
        )}
      </MobileMenuTilesContainer>
    </MobileMenuTilesWrapper>
  );
}
